export const date = {
  differenceInDays: (d1: Date, d2: Date) => {
    const diff = Math.abs(d1.getTime() - d2.getTime());

    return Math.ceil(diff / (1000 * 3600 * 24));
  },
};

export const posixTimestampToUnix = (timestamp: number) => timestamp * 1000;
export const unixTimestampToPosix = (timestamp: number) => timestamp / 1000;
